import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getItemSessionStorage } from "../../features/webStorageSaver";

// Компонент - раздел информации о федеральной дороге
export function FederalRoadInfoSection() {
    // получение id выбранной федеральной дороги из url
    const { roadId } = useParams()
    // определение списка федеральных дорог по выбранным координатам
    let federalRoads: any = getItemSessionStorage('featuresOnMapPoint')?.federalRoadFeatures
    // определение выбранной федеральной дороги из общего списка по id, полученному из url
    const currentFederalRoad = federalRoads.filter((item: any) => item.id === `OSMFederalRoads.${roadId}`)[0]
    return (
        <div className="basic-info-div">
            {currentFederalRoad?.properties &&
                <>
                    <Row>
                        <div className="section-name">Информация о федеральной дороге</div>
                    </Row>
                    <Row>
                        <Col xl>
                            {currentFederalRoad.properties.RoadCipher &&
                                <Row>
                                    <Col lg className="field">Учетный номер</Col>
                                    <Col lg className="value">{currentFederalRoad.properties.RoadCipher}</Col>
                                </Row>
                            }
                            {currentFederalRoad.properties._ACCOUNTNU &&
                                <Row>
                                    <Col lg className="field">Идентификационный номер</Col>
                                    <Col lg className="value">{currentFederalRoad.properties._ACCOUNTNU}</Col>
                                </Row>
                            }
                            {currentFederalRoad.properties.KM_START &&
                                <Row>
                                    <Col lg className="field">Начало участка, КМ</Col>
                                    <Col lg className="value">{currentFederalRoad.properties.KM_START}</Col>
                                </Row>
                            }
                        </Col>
                        <Col xl>
                            {currentFederalRoad.properties.PATHNAME &&
                                <Row>
                                    <Col lg className="field">Участок обслуживания</Col>
                                    <Col lg className="value">{currentFederalRoad.properties.PATHNAME}</Col>
                                </Row>
                            }
                            {currentFederalRoad.properties._FULLNAME &&
                                <Row>
                                    <Col lg className="field">Управляющая организация</Col>
                                    <Col lg className="value">{currentFederalRoad.properties._FULLNAME}</Col>
                                </Row>
                            }
                            {currentFederalRoad.properties.KM_END &&
                                <Row>
                                    <Col lg className="field">Окончание участка, КМ</Col>
                                    <Col lg className="value">{currentFederalRoad.properties.KM_END}</Col>
                                </Row>
                            }
                        </Col>
                        <Col xl>
                            {currentFederalRoad.properties._ROADNAME &&
                                <Row>
                                    <Col lg className="field">Наименование</Col>
                                    <Col lg className="value">{currentFederalRoad.properties._ROADNAME}</Col>
                                </Row>
                            }
                            {currentFederalRoad.properties._STATE &&
                                <Row>
                                    <Col lg className="field">Примечание</Col>
                                    <Col lg className="value">{currentFederalRoad.properties._STATE}</Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </>
            }
        </div>
    );
}

